/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';
import _get from 'lodash/get';
import _size from 'lodash/size';
import _findIndex from 'lodash/findIndex';
import { connect } from 'react-redux';
import { readCookie } from '../../../../src/utils/Cookie';
import { signInCheck } from '../../../components/common/CheckUserStatus';
import { gtmEventPush, gtmPagePush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import {
  addAddress,
  editAddress,
  postalCodeFetch,
  setPinCode,
  setPostalCode,
  resetPostalData,
  setDelivery,
  setCheckedAddress,
  resetPostalCode
} from '../../actions/addressBook';
import { hideModal } from '../../../actions/modal';
import {
  validateMobile,
  validateUsername,
  validatePincode,
  validateASCIIChars,
  validateFirstName,
  validateOthersAddressName,
  validateLandmark
} from './../../../utils/inputValidator';
import { changeAddressSelectionOnCart, getCart } from '../../../cart/actions/cart';
import { isServerRendering } from '../../../utils/pageInfo.js';
import { fetchCartItemsEDDFromClient } from '../../../edd/actions/index.js';
import cleverTapPushEvent from '../../../modules/ajio-util/cleverTap/eventUtils';
import CLEVERTAP_EVENT_NAMES from '../../../modules/ajio-util/cleverTap/eventConstants';
import Input from '../../../refresh/molecules/Input';
import Icon from '../../../refresh/atoms/Icon';
import Text from '../../../refresh/atoms/Text';
import ResetAddressLuxe from './ResetAddressLuxe';

import Button from '../../../refresh/atoms/button';

import BackArrow from '../../../refresh/atoms/BackArrow';
import screen from '../../../refresh/constants/pageType.constant';
import { getEncodedString } from '../../../modules/ajio-util/stringDecoder';
import { getLuxeFlags } from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import Dialog from '../../../refresh/molecules/Dialog';
import luxeScreens from '../../../refresh/constants/luxeScreenType';
import { jioAdsLocationEvent } from '../../../utils/jioAds';
import readAloudFormErrors from '../../../utils/accessibility';
import { chechRushAvailability } from '../../../actions/shared/ajioRush';
import { setSelectedBillingAddress } from '../../../cart/actions/gst';

const userId = decodeURIComponent(readCookie('U')) || '';
const style = Object.freeze({
  fontSize: '2.2rem',
  fontWeight: 'bold'
});
const styles = {
  floatingLabelFocusStyle: {
    fontSize: '12px',
    left: '1px'
  },
  inputStyle: {
    fontSize: '14px',
    height: '60px',
    paddingBottom: '8px'
  },
  textAreaStyle: {
    fontSize: '14px',
    paddingBottom: '8px'
  },
  floatingLabelShrinkStyle: {
    lineHeight: '2px',
    left: '1px'
  },
  floatingLabelShrinkStyleTextArea: {
    left: '1px'
  }
};

function isEDDRequired(url = '') {
  if (isServerRendering()) {
    return url.includes('/shipping') || url.includes('/addresses'); //have to check
  } else {
    const { location: { pathname = '' } = {} } = window;
    return pathname.includes('/shipping') || pathname.includes('/addresses');
  }
}
const { defaultStore, manageAddress = {} } = luxeScreens;
const { screenType = '', screenName = '' } = manageAddress;
class AddAddress extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.props;
    let profileName = decodeURI(readCookie('un'));
      console.log("🚀 ~ AddAddress ~ constructor ~ profileName:", profileName)
      // (props.personalInfo && props.personalInfo.profile && props.personalInfo.profile.name) || '';
    let addressPoc = (this.state.address && this.state.address.addressPoc) || '';
    if (this.props.addrFormType !== 'Edit') {
      addressPoc = addressPoc || profileName;
    }
    const { firstName = '', lastName = '' } = this.props.address || {};

    if (this.props.addrFormType === 'Edit' && addressPoc === '') {
      if (firstName.length + lastName.length > 63) {
        addressPoc = firstName;
      } else {
        addressPoc = firstName.trim() + ' ' + lastName.trim();
      }
    }
    (this.address = {
      ...this.state.address,
      phone:
        (this.state.address && this.state.address.phone) ||
        readCookie('MN') ||
        (props.personalInfo.profile && props.personalInfo.profile.mobileNumber),
      addressPoc
    }),
      (this.addAddressSubmit = this.addAddressSubmit.bind(this));
    this.state = {
      ...this.state,
      address: this.address,
      errAddressPoc: '',
      errLandmark: '',
      errLastName: '',
      errMob: '',
      errPinCode: '',
      errCityDistrict: '',
      errMobileNum: '',
      errAltMobNum: '',
      errAddressLine1: '',
      errAddressLine2: '',
      defaultBoxChecked: false,
      isNewAddressDefault: false,
      addressLine3: '',
      errState: '',
      errCustomAddress: '',
      removeFromBagModal: false,
      rushResetButtonClick: false
    };
    this._saveAddressCallback = this.saveAddressCallback.bind(this);
    this.addAddressFormRef = React.createRef();
    this.modalRef = React.createRef();
    this.trapFocus = this.trapFocus.bind(this);
    this.previousActiveElement = null;
  }

  saveAddressCallback(addresses = []) {
    if(this.props.isBilling){
      this.props.setIsBillingAddressChange(false);
      this.setState({ isNewAddressDefault: false });
      if (this.props.isCartFlow) {
        this.props.closeAllAddressMsite();
      }
      return;
    };
    const { address = {} } = this.state;
    let { defaultAddress = '' } = address;
    let {
      addrFormType,
      isPageType,
      setCheckedAddress,
      callback,
      entryNumber,
      handleAddressUpdate,
      fromCart,
      updateAddressOnCart,
      enablePriorityDeliveryPhase2
    } = this.props;
    let touchIndex;
    if (isPageType == 'shipping') {
      if (addrFormType === 'Edit') {
        const indexOfEditedAddress = _findIndex(addresses, ['id', entryNumber]);
        touchIndex = indexOfEditedAddress;
        setCheckedAddress(
          entryNumber,
          addresses[indexOfEditedAddress].postalCode,
          indexOfEditedAddress
        );
      } else {
        const indexOfAddedAddress = _size(addresses) === 1 || defaultAddress ? 0 : 1;
        touchIndex = indexOfAddedAddress;
        const { id, postalCode } = _get(addresses, [indexOfAddedAddress], {});
        setCheckedAddress(id, postalCode, indexOfAddedAddress);
      }
    }
    if (this.props.callback) {
      const gaEventParams = {
        postalCode: addresses[touchIndex]?.postalCode,
        state: addresses[touchIndex]?.state,
        selectedAddressType: addresses[touchIndex]?.selectedAddressType
      };
      this.props.callback(addresses, addrFormType, gaEventParams);
    }
    const { location: { search = '' } = {} } = window || {};
    if (search.includes('shipping')) {
      if (this.props.addrFormType !== 'Edit') {
        window.location = '/shipping';
      }
    }
    if (handleAddressUpdate) {
      const indexOfAddedAddress = _size(addresses) === 1 || this.state.isNewAddressDefault || enablePriorityDeliveryPhase2 ? 0 : 1;
      const addedAddress = _get(addresses, [indexOfAddedAddress], {});
      if(fromCart || Boolean(signInCheck())) {
        updateAddressOnCart({ addressId: addedAddress?.id });
      }
      handleAddressUpdate(addedAddress);
      this.setState({ isNewAddressDefault: false });
    }
    if (this.props.isCartFlow) {
      this.props.closeAllAddressMsite();
    }
  }

  getCartPincode() {
    const userCurrentAddress = readCookie('USER_ADDR');
    const userCurrentAddressObj = (userCurrentAddress && JSON.parse(userCurrentAddress)) || {};
    return this.props.enablePriorityDeliveryPhase2
      ? userCurrentAddressObj?.pincode
      : readCookie('CPIN');
  }

  componentWillMount() {
    this.props.resetPostalData();
  }

  componentDidMount() {
    document.addEventListener('keydown', this.trapFocus);
    if(this.addAddressFormRef.current){{
      this.addAddressFormRef.current.focus()
    }}
   
    let { address = {}, addrFormType, name, luxeFlags = {}, addressSelected } = this.props;
    const { isThemeEnable } = luxeFlags;
    // const comp = isMsiteRefresh() ? NewLandingPage : OldLandingPage;
    let { line1 = '', town = '', defaultAddress = false } = address;
    const addressLine3 = town ? `${line1}, ${town}` : line1;
    this.setState({ addressLine3, defaultBoxChecked: defaultAddress });
    const { defaultStore, manageAddress = {} } = luxeScreens;
    let { screenType = '', screenName = '' } = manageAddress;
    const luxe = isThemeEnable === 'ON' && name === 'luxe';
    const cartPincode = this.getCartPincode();
    if (cartPincode?.length === 6 && !addressSelected) {
      this.handlePostalCode({ postalCode: cartPincode });
    }
    if (addressSelected) {
      this.state.address.postalCode = '';
    }
    if (luxe) {
      gtmEventPush({
        event: 'form_initiate',
        event_category: 'form interactions',
        event_action: 'Initiate',
        event_label: addrFormType == 'Edit' ? 'Edit address' : 'Add address',
        store_type: name || defaultStore,
        page_name: addrFormType == 'Edit' ? `Update ${screenName}` : `Create ${screenName}`,
        page_type: screenType
      });
    } else {
      gtmEventPush({
        event: 'form_initiate',
        form_name: addrFormType == 'Edit' ? 'Edit address' : 'Add address'
      });
    }

    const { manageAddress: { pageType = '' } = {} } = screen;
    //removed for duplicate page view calls - take up later , suggested by product ^& dev team
    // gtmPagePush(
    //   addrFormType == 'Edit' ? 'update address screen shipping' : 'create address screen shipping',
    //   pageType,
    //   window.__ENV__ || '',
    //   {
    //     store: name
    //   }
    // );
    
    if (this.addAddressFormRef.current) {
      const firstElement = this.addAddressFormRef.current.querySelector(
        'button:not(:disabled), [href]:not([aria-disabled="true"]), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])'
      );
      if (firstElement) {
        firstElement.focus();
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const cartPincode = this.getCartPincode();

    if (prevProps.showAddAddress !== this.props.showAddAddress) {
      if (!this.props.showAddAddress) {
        this.setState(state => {
          return {
            ...state,
            defaultBoxChecked: this.address.defaultAddress,
            address: {
              ...state.address,
              line1: '',
              line2: '',
              landmark: '',
              addressPoc: state.address.addressPoc,
              phone: state.address.phone,
              postalCode: ''
            },
            addressLine3: ''
          };
        });
        this.props.resetPostalData();
        // const cartPincode = this.getCartPincode();
        if (cartPincode?.length === 6 && !this.props.addressSelected) {
          this.handlePostalCode({ postalCode: cartPincode });
        }
      } else {
        if (this.props.addressSelected) {
          this.setState(state => {
            return {
              ...state,
              defaultBoxChecked: this.address.defaultAddress,
              address: {
                ...state.address,
                line1: '',
                line2: '',
                landmark: '',
                addressPoc: state.address.addressPoc,
                phone: state.address.phone,
                postalCode: '',
                ...(this.props.enableRushDelivery && this.props.addAddressDetails
                  && {
                      district: this.props.addAddressDetails?.currCity?.toUpperCase(),
                      postalCode: this.props.addAddressDetails?.currPincode,
                      state: this.props.addAddressDetails?.currState?.toUpperCase(),
                      line2: this.props.addAddressDetails?.strippedAddress,
                      latitude:this.props.addAddressDetails?.location?.lat,
                      longitude:this.props.addAddressDetails?.location?.lng,
                    }
                  )
              },
              addressBook: {
                ...state.addressBook,
                postalData: {
                  ...state.addressBook.postalData,
                  city: '',
                  district: ''
                }
              },
              addressLine3: ''
            };
          });
          this.props.resetPostalData();
        } else if(prevState?.address?.postalCode !== cartPincode) {
          this.setState(state => {
            return {
              ...state,
              address: {
                ...state.address,
                postalCode: cartPincode,
              }
            }
          });
        }
      }
    }
    if (prevProps.pinCodeSet !== this.props.pinCodeSet) {
      const cartPincode = this.getCartPincode();
      if (cartPincode?.length === 6 && !this.props.addressSelected) {
        this.handlePostalCode({ postalCode: cartPincode });
      }
    }

    if (prevProps.addressSelected !== this.props.addressSelected) {
      console.log(
        'address addressSelected previously = ',
        prevProps.addressSelected,
        'address addressSelected now = ',
        this.props.addressSelected
      );
      if (this.props.addressSelected) {
        this.setState(state => {
          return {
            ...state,
            defaultBoxChecked: this.address.defaultAddress,
            address: {
              ...state.address,
              line1: '',
              line2: '',
              landmark: '',
              addressPoc: state.address.addressPoc,
              phone: state.address.phone,
              postalCode: '',
              ...(this.props.enableRushDelivery && this.props.addAddressDetails
                && {
                    district: this.props.addAddressDetails?.currCity.toUpperCase(),
                    postalCode: this.props.addAddressDetails?.currPincode,
                    state: this.props.addAddressDetails?.currState.toUpperCase(),
                    line2: this.props.addAddressDetails?.strippedAddress,
                    latitude:this.props.addAddressDetails?.location?.lat,
                    longitude:this.props.addAddressDetails?.location?.lng,
                  }
                )
            },
            addressLine3: ''
          };
        });
      } else {
        this.setState(state => {
          return {
            ...state,
            defaultBoxChecked: this.address.defaultAddress,
            address: {
              ...state.address,
              line1: '',
              line2: '',
              landmark: '',
              addressPoc: state.address.addressPoc,
              phone: state.address.phone
            },
            addressLine3: ''
          };
        });
      }
    }
  }

  trapFocus = (event) => {
    if (!this.modalRef.current) return;
      const focusableElements = Array.from(
      this.modalRef.current.querySelectorAll(
        'button:not(:disabled), [href]:not([aria-disabled="true"]), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => !el.hasAttribute('disabled') && el.tabIndex !== -1);
    if (focusableElements.length === 0) return;
  
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
  
    if (event.key === 'Tab') {
      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }
  };

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleTrapFocus);
    if (this.previousActiveElement) {
      this.previousActiveElement.focus();
    }
  }

  showDialog(e) {
    e.preventDefault();
    let { removeFromBagModal } = this.state;

    this.setState({ removeFromBagModal: !removeFromBagModal });
  }

  handleInputChange(newPartialInput) {
    let inputObjKey = Object.keys(newPartialInput)[0];
    let inputObjVal = Object.values(newPartialInput)[0];

    if (inputObjKey == 'addressPoc') {
      if (validateFirstName(inputObjVal)) {
        this.setState({
          errAddressPoc: ''
        });
      } else {
        this.setState({
          errAddressPoc: 'Accepts only alphabets & spaces between words.'
        });
      }
    }
    // if (inputObjKey == "firstName") {
    //   if (validateFirstName(inputObjVal)) {
    //     this.setState({
    //       errFirstName: ""
    //     })
    //   } else {
    //     this.setState({
    //       errFirstName: "Accepts only alphabets & spaces between words."
    //     })
    //   }
    // }
    else if (inputObjKey == 'landmark') {
      if (validateLandmark(inputObjVal)) {
        this.setState({
          errLandmark: ''
        });
      } else if (inputObjVal.length === 0) {
        this.setState({
          errLandmark: ''
        });
      } else {
        this.setState({
          errLandmark: 'Special characters are not allowed'
        });
      }
    }
    // else if (inputObjKey == "lastName") {
    //   if (validateUsername(inputObjVal)) {
    //     this.setState({
    //       errLastName: ""
    //     })
    //   }
    //   else {
    //     this.setState({
    //       errLastName: "Accepts only alphabets & spaces between words."
    //     })
    //   }
    // }
    else if (inputObjKey == 'postalCode') {
      if (validatePincode(inputObjVal)) {
        this.setState({
          errPinCode: ''
        });
      } else {
        this.setState({
          errPinCode: 'Enter valid Pincode'
        });
      }
    } else if (inputObjKey == 'line1') {
      this.setState({ addressLine3: inputObjVal });
      if (inputObjVal !== '') {
        this.setState({
          errAddressLine1: ''
        });
      } else {
        this.setState({
          errAddressLine1: 'Enter valid  Flat no/Building Name'
        });
      }
    } else if (inputObjKey == 'line2') {
      if (inputObjVal !== '') {
        this.setState({
          errAddressLine2: ''
        });
      } else {
        this.setState({
          errAddressLine2: 'Enter valid Locality / Area / Street'
        });
      }
    } else if (inputObjKey == 'district') {
      if (validateUsername(inputObjVal)) {
        this.setState({
          errCityDistrict: ''
        });
      } else {
        this.setState({
          errCityDistrict: 'Please enter a valid city/district.'
        });
      }
    } else if (inputObjKey == 'phone') {
      if (validateMobile(inputObjVal)) {
        this.setState({
          errMobileNum: ''
        });
      } else {
        this.setState({
          errMobileNum: 'Please enter a valid 10 digit mobile number.'
        });
      }
    } else if (inputObjKey == 'altMobNum') {
      if (validateMobile(inputObjVal)) {
        this.setState({
          errAltMobNum: ''
        });
      } else {
        this.setState({
          errAltMobNum: 'Please enter a valid 10 digit mobile number.'
        });
      }
    }
    if (inputObjKey == 'customAddressType') {
      if (validateOthersAddressName(inputObjVal)) {
        this.setState({
          errCustomAddress: ''
        });
      } else {
        this.setState({
          errCustomAddress: 'Accepts only alphabets & spaces between words.'
        });
      }
    }
    this.setState(state => ({
      ...state,
      address: {
        ...state.address,
        ...newPartialInput
      }
    }));
  }

  handleResetButton(event, initialaddresss = {}, luxe) {
    event.stopPropagation();
    event.preventDefault();
    let { line1 = '', town = '' } = initialaddresss;

    const addressLine3 = town ? `${line1}, ${town}` : line1;
    let { name, addrFormType } = this.props;
    // if(this.props.addrFormType === 'Add' ){
    // let {phone } = this.state.address;
    // initialaddresss.phone = phone;
    // let {addressPoc } = this.state.address;
    //   initialaddresss.addressPoc = addressPoc;
    // }

    this.props.resetPostalData();
    this.setState(state => {
      return {
        ...state,
        defaultBoxChecked: this.address.defaultAddress,
        address: this.props.isCartFlow ? { ...this.address, postalCode: '' } : this.address,
        addressLine3: this.props.isCartFlow ? '' : addressLine3,
        rushResetButtonClick: this.props.enableRushDelivery && true
      };
    });
    if (luxe && !this.props.enableRushDelivery) {
      const { defaultStore, manageAddress = {} } = luxeScreens;
      let { screenType = '', screenName = '' } = manageAddress;

      gtmEventPush({
        event: addrFormType == 'Edit' ? 'edit_reset' : 'add_reset',
        event_category: 'checkout interactions',
        event_action: addrFormType == 'Edit' ? 'Edit reset' : 'Add reset',
        event_label: addrFormType == 'Edit' ? 'Edit reset' : 'Add reset',
        store_type: name || defaultStore,
        page_name: addrFormType === 'Edit' ? `Update ${screenName}` : `Create ${screenName}`,
        page_type: screenType
      });
      this.setState({ removeFromBagModal: !this.state.removeFromBagModal });
    }

    // this.showDialog()
  }

  handlePostalCode(newPartialInput) {
    //Here Code to get the API Call
    let { postalCode = '' } = newPartialInput;
    if (postalCode?.length == 6) {
      this.props.getlocationFromPostalCode(newPartialInput);
    }
    this.handleInputChange(newPartialInput);
  }

  checkMandatoryFields = (
    postalCode,
    addressPoc,
    line1,
    line2,
    district,
    phone,
    state,
    luxe,
    addrFormType
  ) => {
    let { name } = this.props;
    let { errLandmark } = this.state;
    let errorMsg = '';

    if (postalCode == '') {
      this.setState({
        errPinCode: 'Enter valid Pincode'
      });
      errorMsg = 'Enter valid Pincode';
    }
    if (addressPoc == '') {
      this.setState({
        errAddressPoc: 'Enter valid  Name'
      });
      errorMsg = 'Enter valid  Name';
    }
    // if (firstName == "") {
    //   this.setState({
    //     errFirstName: "Enter valid First Name"
    //   })
    // }
    // if (lastName == "") {
    //   this.setState({
    //     errLastName: "Enter valid Last Name"
    //   })
    // }
    if (validateASCIIChars(line1).trim().length === 0) {
      this.setState({
        errAddressLine1: 'Enter valid  Flat no/Building Name'
      });
      errorMsg = 'Enter valid  Flat no/Building Name';
    }
    if (validateASCIIChars(line2).trim().length === 0) {
      this.setState({
        errAddressLine2: 'Enter valid Locality / Area / Street'
      });
      errorMsg = 'Enter valid Locality / Area / Street';
    }
    if (district == '') {
      this.setState({
        errCityDistrict: 'Please enter a City/District'
      });
      errorMsg = 'Please enter a City/District';
    }
    if (state == '') {
      this.setState({
        errState: 'Please enter a state'
      });
      errorMsg = 'Please enter a state';
    }
    let isNotValidMobileNum =
      phone == '' || isNaN(phone) || phone.indexOf(' ') != -1 || phone.length !== 10;
    if (isNotValidMobileNum) {
      this.setState({
        errMobileNum: 'Please enter a valid 10 digit mobile number.'
      });
      errorMsg = 'Please enter a valid 10 digit mobile number.';
    }
    if (
      postalCode == '' ||
      addressPoc == '' ||
      validateASCIIChars(line1).trim().length === 0 ||
      validateASCIIChars(line2).trim().length === 0 ||
      district == '' ||
      state == '' ||
      isNotValidMobileNum ||
      errLandmark != ''
    ) {
      if (luxe) {
        gtmEventPush({
          event: 'form_error',
          event_category: 'form interactions',
          event_action: 'error',
          store_type: name,
          event_label:
            addrFormType == 'Edit'
              ? `Update ${screenName} ${errorMsg}`
              : `Create ${screenName} ${errorMsg}`,
          page_name: addrFormType === 'Edit' ? `Update ${screenName}` : `Create ${screenName}`,
          page_type: screenType
        });
      }
      return false;
    } else {
      return true;
    }
  };

  scrollToError = () => {
    this.errorMessages.scrollIntoView({ behavior: 'smooth' });
  };

  addAddressSubmit = async (                      //submit function for add address
    event,
    postalCode,
    addressPoc,
    line1,
    district,
    phone,
    line2,
    town,
    landmark,
    altMobNum,
    defaultAddress,
    state,
    selectedAddressType,
    customAddressType,
    luxe
  ) => {
    event.preventDefault();
    const {
      entryNumber,
      addrFormType,
      isPageType = '',
      editAddressCheckout,
      editAddress,
      setCheckedAddress,
      fetchCartItemsEDDFromClient,
      setDelivery,
      addAddress,
      name,
      enablePriorityDeliveryPhase2=false,
      chechRushAvailability,
      geoTagFromCart,
      isBilling = false,
      addressBook,
      setSelectedBillingAddress
    } = this.props;
    if(this.props.enableRushDelivery) {
      this.props.makeAddAddressFalse();
    }
    cleverTapPushEvent({
      eventName: CLEVERTAP_EVENT_NAMES.Address_Added,
      eventObj: {
        type: selectedAddressType,
        pinCode: postalCode,
        city: district,
        state: state,
        user_id: userId != 'null' ? userId : 'anonymous',
        platform: 'MSITE'
      }
    });
    const { defaultStore, manageAddress = {} } = luxeScreens;
    let { screenType = '', screenName = '' } = manageAddress;
    if (luxe) {
      gtmEventPush({
        event: 'form_submit',
        event_category: 'form interactions',
        event_action: 'submit',
        store_type: name || defaultStore,
        page_name: addrFormType == 'Edit' ? `Update ${screenName}` : `Create ${screenName}`,
        page_type: screenType
      });
    } else {
      gtmEventPush({
        event: 'form_submit',
        form_name: addrFormType == 'Edit' ? 'Edit address' : 'Add address'
      });
    }

    const addressList = _get(this.props, 'addressBook.addresses', []);
    const mandatoryFieldsFilled = this.checkMandatoryFields(
      postalCode,
      addressPoc,
      line1,
      line2,
      district,
      phone,
      state,
      luxe,
      addrFormType
    );

    const formData = this.addAddressFormRef.current?.elements || [];
    let addAddrData = {};
    const latData = this.props.addAddressDetails?.location?.lat;
    const longData = this.props.addAddressDetails?.location?.lng;
    
    for (let idx = 0, len = formData.length; idx < len; idx++) {
      let { name = '', value = '', checked = false } = formData[idx] || {};
      if (name) {
        if (name == 'defaultAddress') {
          addAddrData[name] = checked;
        } else {
          if (name === 'selectedAddressType') {
            if (checked) {
              const validValue = validateASCIIChars(value);
              addAddrData[name] = getEncodedString(validValue.trim());
            }
          } else {
            const validValue = validateASCIIChars(value);
            addAddrData[name] = getEncodedString(validValue.trim());
          }
        }
      }
    }
    if(this.props.enableRushDelivery && geoTagFromCart && addrFormType == 'Edit'){
      addAddrData['id'] =geoTagFromCart;
      this.props.makeGeoTagFromCart();
    }

    //Dispactching an action to addAddress
    if (mandatoryFieldsFilled) {
      if(this.props.enableRushDelivery && this.props.addAddressDetails?.location){      //give lat and long to newly added address
        addAddrData.latitude = latData && latData.toFixed(4);
        addAddrData.longitude = longData && longData.toFixed(4);
        const userCurrentAddress = readCookie('USER_ADDR');                   //TODO ask KK for this
        const userCurrentAddressObj = (userCurrentAddress && JSON.parse(userCurrentAddress)) || {};
        if(!addAddrData.id && userCurrentAddressObj?.addressId){
          addAddrData.id = userCurrentAddressObj?.addressId;
        }
        if(!addAddrData?.addressPoc){
          addAddrData.addressPoc = userCurrentAddressObj?.addressPoc;
        }
        if(!addAddrData?.defaultAddress && !isBilling){
          addAddrData.defaultAddress= true;                //make the address that is being edited as default(currently selected)
        }
      }
      if (addrFormType == 'Edit') {
        if(!this.props.enableRushDelivery && entryNumber){
          addAddrData['id'] = entryNumber;
        }
        if (isPageType == 'checkout') {
          editAddressCheckout(addAddrData);
        } else {
          await editAddress(addAddrData, this._saveAddressCallback);

          luxe &&
            gtmEventPush({
              event: 'edit_save',
              event_category: 'checkout interactions',
              event_action: 'edit save',
              store_type: name || defaultStore,
              event_label: 'Edit address',
              page_name: `Update ${screenName}}`,
              page_type: screenType
            });
          if (isEDDRequired()) {
            fetchCartItemsEDDFromClient(addAddrData.postalCode).then(response => {
              if (response.status.statusCode === 0) {
                const { pinCode, servicability, codEligible } = response;
                if (!servicability) {
                  window.ga &&
                    window.ga('send', {
                      hitType: 'event',
                      eventCategory: 'buttonTap',
                      eventAction: 'EDD on Shipping Page',
                      eventLabel: `Proceed to payment disabled - ${pinCode}`
                    });
                }
              }
            });
          }
          const { location: { pathname = '', search = '' } = {} } = window || {};
          const isReferrerShippingPage =
            pathname.includes('/my-account/address-book') && search.includes('shipping');
          if (isReferrerShippingPage) {
            setDelivery(this.props.entryNumber);
          }
        }
        this.props.setPinCode(postalCode);
      } else {
        if(this.props.enableRushDelivery && addAddrData?.defaultAddress){                       //check rush availability only if default address
          let location = {lat:this.props?.addAddressDetails?.location?.lat,long:this.props?.addAddressDetails?.location?.lng};
          chechRushAvailability(addAddrData?.postalCode, location);
        }
        await addAddress(addAddrData, this._saveAddressCallback);
        luxe &&
          gtmEventPush({
            event: 'add_new_save',
            event_category: 'checkout interactions',
            event_action: 'add new save',
            store_type: name || defaultStore,
            event_label: 'Add address',
            page_name: `Create ${screenName}`,
            page_type: screenType
          });
      }
    } else {
      this.scrollToError();
    }
    let { address: initialaddresss = {}, device = '' } = this.props;
    let { line1: addressline1 = '', town: city = '' } = initialaddresss;
    const addressLine3 = town ? `${addressline1}, ${city}` : addressline1;
    if(this.props.enableRushDelivery && !mandatoryFieldsFilled){      //not required to reset fileds in case of rush(preselected fields)
      return;
    }
    this.props.resetPostalData();
    this.setState(state => {
      return {
        ...state,
        defaultBoxChecked: this.address.defaultAddress,
        address: this.address,
        addressLine3
      };
    });

    // update the current address to added address 
    if (!isBilling) {
      this.props.updateAddress({
        pinCode: postalCode,
        lat: latData ? latData.toFixed(4) : undefined,
        long: longData ? longData.toFixed(4) : undefined,
        enableRushDelivery: this.props.enableRushDelivery,
        skipFetchCart: this.props.fromCart ? false : true
      });
    } else {
      const addressObj = {
        line1,line2,phone,postalCode,district,state,
        formattedAddress: `${line1 || ''}, ${line2|| ''}, ${postalCode || ''}`
      };
      if (addressObj) {
        setSelectedBillingAddress(addressObj);
      }
    }

    // window.location('/address-book');
  };

  hideDialog() {
    // setDialogData(null);
    this.setState({ removeFromBagModal: !this.state.removeFromBagModal });
  }
  render() {
    //Setting the Value from the Props
    const {
      address = {},
      addrFormType = 'Add',
      modalName = '',
      addressLine3 = '',
      addressSelected
    } = this.state;
    let { address: initialaddresss = {}, device = '' } = this.props;

    let {
      addressBook: {
        postalData: { district: distNew = '', invalidpostalcode = false, state: stateNew = '' } = {}
      } = {},
      isPageType = '',
      isCartFlow = false,
      enableRushDelivery = false,
      isAddAddress = false,
      addAddressDetails = {},
      reselectMapFunctionality
    } = this.props;

    const cartPincode = this.getCartPincode() || '';

    let {
      id = '',
      firstName = '',
      lastName = '',
      addressPoc = '',
      line1 = '',
      line2 = '',
      line3 = '',
      landmark = '',
      town = '',
      district = '',
      state = '',
      postalCode = isCartFlow ? cartPincode : '',
      phone = '',
      altMobNum = '',
      codEligible = '',
      exchangeService = '',
      selectedAddressType = 'HOME',
      customAddressType = '',
      defaultAddress = '',
      country = {}
    } = address;

    let { isocode = 'IN' } = country;
    let cityDistrict = distNew ? distNew : district;

    cityDistrict = invalidpostalcode ? '' : cityDistrict;
    let newState = stateNew ? stateNew : state;
    newState = invalidpostalcode ? '' : newState;
    const { luxeFlags = {}, name } = this.props;
    const { isThemeEnable } = luxeFlags;
    // const comp = isMsiteRefresh() ? NewLandingPage : OldLandingPage;
    const luxe = isThemeEnable === 'ON' && name === 'luxe';
    const rushCssClass4StickyButton = enableRushDelivery ? "rushStickyButton" : "";
    const rushSaveButton = enableRushDelivery ? "rushSaveButton" : "";


    return (
      <div className="address-content">
        <form
          className="add-address-form"
          id="addAddressForm"
          ref={this.addAddressFormRef}
          onSubmit={e => {
            this.addAddressSubmit(
              e,
              postalCode,
              addressPoc,
              line1,
              cityDistrict,
              phone,
              line2,
              town,
              landmark,
              altMobNum,
              defaultAddress,
              newState,
              selectedAddressType,
              customAddressType,
              luxe
            );
            readAloudFormErrors('.address-error-msg');
          }}
        >
          <div className="add-address-form-container" ref={this.modalRef} >
            {luxe && !enableRushDelivery? (
              <div className="addNewAddressTextLuxe">
                <div onClick={this.props.closeAddAddressMsite}>
                  <BackArrow />
                </div>
                <div>
                  <Text variant="T4" color="Nero" weight="bold" textTransform="is-uppercase">
                    Address
                  </Text>
                </div>
                <button
                  onClick={e => this.showDialog(e)}
                  className={'rilrtl-button button mobaddaddr-reset-luxe'}
                  id="reset-luxe-btn"
                >
                  <strong>Reset</strong>
                </button>
              </div>
            ) : (
              <div className={enableRushDelivery ? "addNewAddressText addNewAddressTextRush" : "addNewAddressText"}>
                <div
                  onClick={() => {
                    if (!addressSelected) {
                      this.handlePostalCode({ cartPincode });
                    }
                    this.props.closeAddAddressMsite();
                  }}
                >
                  <BackArrow />
                </div>
                <Text variant="T2" color="Nero" weight="bold" textTransform="is-capitalized" role='heading' ariaLevel={2}>
                  {this.props.addrFormType == 'Edit' ? 'Edit Address' : 'Add Address'}
                </Text>
                <button
                  onClick={e => this.handleResetButton(e, initialaddresss, luxe)}
                  className={'rilrtl-button button mobaddaddr-reset'}
                  id="reset-luxe-btn"
                  aria-label="Reset"
                >
                  <strong>Reset</strong>
                </button>
              </div>
            )}
            <div className="contact-info-address">
              <Text variant="T4" color="Nero" weight="bold" textTransform="is-capitalized" role='heading' ariaLevel={3}>
                {luxe && !enableRushDelivery? 'CONTACT INFO' : 'Contact Info'}
              </Text>
              <div className="mobaddadddr-input">
                <Input
                  id="addressPocInput"
                  type="text"
                  defaultValue={this.props.enableRushDelivery && this.state.rushResetButtonClick ? '' : addressPoc}
                  onChange={e => this.handleInputChange({ addressPoc: e })}
                  name="addressPoc"
                  size="32"
                  maxLength="64"
                  label="Name"
                  validationError={this.state.errAddressPoc ? true : false}
                  luxe={luxe && !enableRushDelivery}
                  labelHidden={true}
                  // hasFromAddAddress={true}
                />
                <span
                  id="addressPocInput-error"
                  className="address-error-msg"
                  aria-live="polite"
                >
                  {this.state.errAddressPoc}
                </span>
              </div>

              <div className="mobaddadddr-input">
                <Input
                  id="phoneNumberInput"
                  type="tel"
                  defaultValue={this.props.enableRushDelivery && this.state.rushResetButtonClick ? '' : phone}
                  onChange={e => this.handleInputChange({ phone: e })}
                  name="phone"
                  size="32"
                  maxLength="10"
                  label="Phone Number (+91)"
                  validationError={this.state.errMobileNum ? true : false}
                  luxe={luxe && !enableRushDelivery}
                  // ariaLabel={phone?.split('').join('\u00A0')}
                  // hasFromAddAddress={true}
                  ariaLabel={phone ? `Phone Number (+91): ${phone}` : 'Phone Number (+91)'}
                  labelHidden={true}
                />
                <div
                  id="phoneNumberInput-error"
                  ref={el => {
                    this.errorMessages = el;
                  }}
                  className="address-error-msg"
                  aria-live="polite"
                >
                  {this.state.errMobileNum}
                </div>
              </div>
            </div>

            <div className="address-info-section">
              <Text variant="T4" color="Nero" weight="bold" textTransform="is-capitalized" role='heading' ariaLevel={3}>
                {luxe && !enableRushDelivery? 'ADDRESS INFO' : 'Address Info'}
              </Text>
              <input type="hidden" name="country.isocode" value={isocode} />
              <div className="mobaddadddr-input">
                <div className="cityPincode">
                  <div className="pincode">
                    <Input
                      id="postalCodeInput"
                      type="tel"
                      numericOnly
                      defaultValue={postalCode ? postalCode : (enableRushDelivery && isAddAddress && addAddressDetails?.currPincode ? addAddressDetails?.currPincode : '')}
                      onChange={e => this.handlePostalCode({ postalCode: e })}
                      name="postalCode"
                      size="32"
                      maxLength="6"
                      label="Pincode"
                      validationError={this.state.errPinCode || invalidpostalcode ? true : false}
                      luxe={luxe && !enableRushDelivery}
                      disabled={enableRushDelivery && isAddAddress && addAddressDetails?.currPincode ? true : false}
                      ariaLabel={postalCode ? `Pincode: ${postalCode}` : 'Pincode'}
                      labelHidden={true}
                      // hasFromAddAddress={true}
                    />
                    {invalidpostalcode ? (
                      <span id='postalCodeInput-error' className="address-error-msg" aria-live="polite">
                        {' '}
                        Sorry, the pincode entered is either invalid or non serviceable{' '}
                      </span>
                    ) : (
                      this.state.errPinCode && (
                        <span id='postalCodeInput-error' className="address-error-msg" aria-live="polite">
                          {this.state.errPinCode}
                        </span>
                      )
                    )}
                  </div>
                  <div className="city">
                    <Input
                      id="districtInput"
                      type="text"
                      defaultValue={cityDistrict ? cityDistrict : (enableRushDelivery && isAddAddress && addAddressDetails?.currCity ? addAddressDetails?.currCity.toUpperCase() : '')}
                      onChange={e => this.handleInputChange({ district: e })}
                      name="district"
                      size="32"
                      maxLength="30"
                      readOnly
                      label="City"
                      validationError={!cityDistrict || invalidpostalcode ? true : false}
                      luxe={luxe && !enableRushDelivery}
                      disabled={enableRushDelivery && isAddAddress && addAddressDetails?.currCity ? true : false}
                      ariaLabel={cityDistrict ? `City: ${cityDistrict}` : 'City'}
                      labelHidden={true}
                      // hasFromAddAddress={true}
                    />
                    {invalidpostalcode ? (
                      <span id='districtInput-error' className="address-error-msg" aria-live="polite">
                        {' '}
                        Please enter a City/District{' '}
                      </span>
                    ) : this.state.errCityDistrict && !cityDistrict ? (
                      <span id='districtInput-error' className="address-error-msg" aria-live="polite">
                        {this.state.errCityDistrict}
                      </span>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="mobaddadddr-input">
                <Input
                  id="stateInput"
                  type="text"
                  defaultValue={newState? newState : (enableRushDelivery && isAddAddress && addAddressDetails?.currState ? addAddressDetails?.currState.toUpperCase() : '')}
                  onChange={e => this.handleInputChange({ state: e })}
                  readOnly
                  name="state"
                  size="32"
                  maxLength="30"
                  label="State"
                  validationError={this.state.errState ? true : false}
                  luxe={luxe && !enableRushDelivery}
                  disabled={enableRushDelivery && isAddAddress && addAddressDetails?.currState ? true : false}
                  ariaLabel={newState ? `State: ${newState}` : 'State'}
                  labelHidden={true}
                  // hasFromAddAddress={true}
                />
                {this.state.errState && !newState ? (
                  <span id='stateInput-error' className="address-error-msg" aria-live="polite">
                    {this.state.errState}
                  </span>
                ) : null}
              </div>

              <div className="mobaddadddr-input">
                <Input
                  id="line2Input"
                  type="text"
                  defaultValue={line2 ? line2 : (enableRushDelivery && isAddAddress && addAddressDetails?.strippedAddress && !this.state.rushResetButtonClick ? addAddressDetails?.strippedAddress : '')}
                  onChange={e => this.handleInputChange({ line2: e })}
                  name="line2"
                  size="32"
                  maxLength="200"
                  label="Locality / Area / Street"
                  validationError={this.state.errAddressLine2 ? true : false}
                  luxe={luxe && !enableRushDelivery}
                  ariaLabel={line2 ? `Locality / Area / Street: ${line2}` : 'Locality / Area / Street'}
                  labelHidden={true}
                  // hasFromAddAddress={true}
                />
                <span id='line2Input-error' className="address-error-msg" aria-live="polite">
                  {this.state.errAddressLine2}
                </span>
              </div>
              <div className="mobaddadddr-input">
                <Input
                  id="line1Input"
                  type="text"
                  defaultValue={addressLine3}
                  onChange={e => this.handleInputChange({ line1: e })}
                  name="line1"
                  size="32"
                  maxLength="30"
                  label="Flat no / Building Name"
                  validationError={this.state.errAddressLine1 ? true : false}
                  luxe={luxe && !enableRushDelivery}
                  ariaLabel={addressLine3 ? `Flat no / Building Name: ${addressLine3}` : 'Flat no / Building Name'}
                  labelHidden={true}
                  // hasFromAddAddress={true}
                />
                <span id='line1Input-error' className="address-error-msg" aria-live="polite">
                  {this.state.errAddressLine1}
                </span>
              </div>

              <div className="mobaddadddr-input">
                <Input
                  id="landmarkInput"
                  type="text"
                  defaultValue={landmark}
                  onChange={e => this.handleInputChange({ landmark: e })}
                  name="landmark"
                  size="32"
                  maxLength="30"
                  label="Landmark (optional)"
                  validationError={this.state.errLandmark ? true : false}
                  luxe={luxe && !enableRushDelivery}
                  ariaLabel={landmark ? `Landmark (optional): ${landmark}` : 'Landmark (optional)'}
                  labelHidden={true}
                  // hasFromAddAddress={true}
                />
                <span id='landmarkInput-error' className="address-error-msg" aria-live="polite">
                  {this.state.errLandmark}
                </span>
              </div>
            </div>

            <div className="mobaddadddr-input typeOfAdd">
              <div className="input-box radioButton">
                <Text variant="T4" color="Nero" weight="bold" textTransform="is-capitalized" role='heading' ariaLevel={3}>
                  {luxe && !enableRushDelivery? 'TYPE OF ADDRESS' : 'Type of Address'}
                </Text>

                <div className="addressTypeButton" role='radiogroup'>
                  <div className='radio-option'
                  onClick={e => this.handleInputChange({ selectedAddressType: 'HOME' })}
                  >
                    <input
                      id='radio-home'
                      type="radio"
                      className="radioButton"
                      name="selectedAddressType"
                      checked={selectedAddressType === 'HOME' ? true : false}
                      aria-checked={selectedAddressType === 'HOME'}
                      value="HOME"
                      onChange={e => this.handleInputChange({ selectedAddressType: 'HOME' })}
                    />
                    <Icon
                      ariaHidden={true}
                      icon={
                        selectedAddressType === 'HOME'
                          ? 'icon-Radio-Button-Selected'
                          : 'icon-Radio-Button'
                      }
                      styles={style}
                    />
                    <label className="radio-text" htmlFor='radio-home'>
                      Home
                    </label>
                  </div>
                  <div className='radio-option'>
                    <input
                      id='radio-work'
                      type="radio"
                      className="radioButton"
                      name="selectedAddressType"
                      checked={selectedAddressType === 'WORK' ? true : false}
                      aria-checked={selectedAddressType === 'WORK'}
                      value="WORK"
                      onChange={e => this.handleInputChange({ selectedAddressType: 'WORK' })}
                    />
                    <Icon
                      ariaHidden={true}
                      icon={
                        selectedAddressType === 'WORK'
                          ? 'icon-Radio-Button-Selected'
                          : 'icon-Radio-Button'
                      }
                      styles={style}
                    />
                    <label className="radio-text" htmlFor='radio-work'>
                      {' '}
                      {luxe ? 'Office' : 'Work'}
                    </label>
                  </div>
                  <div className='radio-option'>
                    <input
                      id='radio-other'
                      type="radio"
                      className="radioButton"
                      name="selectedAddressType"
                      checked={selectedAddressType === 'OTHER' ? true : false}
                      aria-checked={selectedAddressType === 'OTHER'}
                      value="OTHER"
                      onChange={e => this.handleInputChange({ selectedAddressType: 'OTHER' })}
                    />
                    <Icon
                      ariaHidden={true}
                      icon={
                        selectedAddressType === 'OTHER'
                          ? 'icon-Radio-Button-Selected'
                          : 'icon-Radio-Button'
                      }
                      styles={style}
                    />
                    <label className="radio-text" htmlFor='radio-other'>
                      Others
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {selectedAddressType == 'OTHER' ? (
              <div className="mobaddadddr-input otherAddress">
                <Input
                  type="text"
                  defaultValue={customAddressType}
                  onChange={e => this.handleInputChange({ customAddressType: e })}
                  name="customAddressType"
                  size="32"
                  maxLength="30"
                  label="Enter Address name"
                  validationError={this.state.errCustomAddress ? true : false}
                />
                <span
                  className="address-error-msg"
                  aria-live="polite"
                  aria-label={this.state.errCustomAddress}
                >
                  {this.state.errCustomAddress}
                </span>
              </div>
            ) : (
              ''
            )}

            <Dialog
              showDialog={this.state.removeFromBagModal}
              type="drawer"
              onCancel={() => this.hideDialog()}
              customClass={'luxe-dialog'}
              ariaLabel="Reset Address"
            >
              <div id="resetDialog">
                <ResetAddressLuxe
                  hideDialog={() => this.hideDialog()}
                  resetButton={e => this.handleResetButton(e, initialaddresss, luxe && !enableRushDelivery)}
                  initialaddresss={initialaddresss}
                ></ResetAddressLuxe>
              </div>
            </Dialog>

            {isPageType != 'checkout' &&  !(isCartFlow && enableRushDelivery) && (
              <div className={enableRushDelivery ? "mobaddaddr-default defaultAddressMsite defaultAddressMsiteRush" : "mobaddaddr-default defaultAddressMsite"}>
                <span>
                  <Icon
                    ariaLabel="default address selection"
                    icon={
                      this.state.defaultBoxChecked ? 'icon-Checkbox-Selected' : 'icon-Check-box'
                    }
                    styles={style}
                    onClick={e => {
                      let newAdresss = Object.assign({}, this.state.address); //creating copy of object
                      newAdresss.defaultAddress = !this.state.address.defaultAddress;
                      //updating value
                      //updating value

                      this.setState({
                        defaultBoxChecked: !this.state.defaultBoxChecked,
                        isNewAddressDefault: !this.state.isNewAddressDefault,
                        address: newAdresss
                      });

                      defaultAddress = !defaultAddress;
                      //this.setState({defaultBoxChecked : !this.state.defaultBoxChecked})}
                    }}
                    ariaHidden={true}
                  />
                  <input
                    type="checkbox"
                    value={this.state.defaultBoxChecked}
                    // defaultChecked={this.state.defaultBoxChecked}
                    id='defaultAddress'
                    name="defaultAddress"
                    checked={this.state.defaultBoxChecked}
                    onChange={e => {}}
                    onClick={e => {
                      // added onClick as two places 
                      // as this area of click is small and when user tries to click this
                      // it does not cick properly
                      let newAdresss = Object.assign({}, this.state.address); //creating copy of object
                      newAdresss.defaultAddress = !this.state.address.defaultAddress;
                      //updating value
                      //updating value

                      this.setState({
                        defaultBoxChecked: !this.state.defaultBoxChecked,
                        isNewAddressDefault: !this.state.isNewAddressDefault,
                        address: newAdresss
                      });

                      defaultAddress = !defaultAddress;
                      //this.setState({defaultBoxChecked : !this.state.defaultBoxChecked})}
                    }}
                    aria-selected={this.state.defaultBoxChecked}
                  />
                  <label htmlFor='defaultAddress'> Make default address</label>
                </span>
              </div>
            )}
          </div>
          <div className={`${luxe && !enableRushDelivery ? `luxe-mobaddaddr-type ${rushCssClass4StickyButton}` : `mobaddaddr-type ${rushCssClass4StickyButton}`}`}>
            <button
              type="submit"
              className={`rilrtl-button button mobaddaddr-save ${rushSaveButton} rushResetLoc`}
              aria-label="Save Address"
              tabIndex={0}
            >
              <strong>Save Address</strong>
            </button>
            {enableRushDelivery && <div className={this.props.fleek ? "rushSetMapLocationAgainFleek rushResetLoc" :"rushSetMapLocationAgain rushResetLoc"} onClick={()=>reselectMapFunctionality()}>                {/*button for triggering Google map again*/}
              Reselect Location on Map
            </div>}
          </div>
        </form>
      </div>
    );
  }
}

const mapStatetoProps = state => {
  const { flags = {} } = state;

  const { addressBook = [], personalInfo = [], httpError = {}, cartItem = [] } = state;

  return {
    addressBook,
    personalInfo,
    httpError,
    luxeFlags: getLuxeFlags(flags),
    name: getCurrentStore(state),
    cartItem
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addAddress: (formData, callback) => {
      dispatch(addAddress(formData, callback, ownProps.closeAddAddressMsite));
      // dispatch(hideModal("address-add"));
    },
    editAddressCheckout: (formData, cb) => {
      dispatch(editAddress(formData, cb));
      dispatch(getCart({ isRequestOrginIsBrowser: true }));
      dispatch(hideModal('address-edit'));
    },
    editAddress: (formData, callback) => {
      dispatch(editAddress(formData, callback, ownProps.closeAddAddressMsite));
      // dispatch(hideModal("address-edit"));
    },
    updateAddress: (addObj) => dispatch(changeAddressSelectionOnCart(addObj)),
    getlocationFromPostalCode: postalCodeObj => {
      dispatch(postalCodeFetch(postalCodeObj));
    },
    setPostalCode: (postalCodeData = {}) => {
      dispatch(setPostalCode(postalCodeData));
    },
    setPinCode: (pincode = '') => {
      dispatch(setPinCode(pincode));
    },
    resetPostalData: () => {
      dispatch(resetPostalCode());
    },
    fetchCartItemsEDDFromClient: pincode => dispatch(fetchCartItemsEDDFromClient(pincode)),
    setDelivery: id => setDelivery(id, dispatch),
    setCheckedAddress: (id, postalCode, index, edd, isStoreAddress) => {
      dispatch(setCheckedAddress(id, postalCode, index, edd, isStoreAddress));
    },
    chechRushAvailability: (pincode,latlong) => dispatch(chechRushAvailability(pincode,latlong)),
    setSelectedBillingAddress: data => dispatch(setSelectedBillingAddress(data))
  };
};

export default AddAddress = connect(mapStatetoProps, mapDispatchToProps)(AddAddress);
// Abhishek's Changes
